export const youtubeAPI = () => {
  const triggers = document.querySelectorAll('.youtube-trigger');
  if (!triggers.length) return;
  console.log(triggers);

  const tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // YouTube iframe APIが読み込まれた後に呼び出される関数
  window.onYouTubeIframeAPIReady = () => {
    triggers.forEach((el) => {
      el.addEventListener('click', () => {
        const youtubeID = el.dataset.youtubeid;
        if (!youtubeID) return;
        createPlayer(el, youtubeID);
      });
    });
  };

  const createPlayer = (el, youtubeID) => {
    const modal = document.createElement('div');
    modal.classList.add('youtube-modal');
    modal.innerHTML = `
      <div class="youtube-modal-content">
        <span class="youtube-modal-close">&times;</span>
        <div id="${youtubeID}"></div>
      </div>
    `;
    document.body.appendChild(modal);

    const player = new YT.Player(youtubeID, {
      videoId: youtubeID,
      playerVars: {
        'autoplay': 1,
        'html5': 1,
        'rel': 0,
        'modestbranding': 1,
        'playsinline': 1,
        /* スマホは全画面再生する */
        'fs': 0,
        'loop': 1,
      },
      events: {
        'onReady': (event) => {
          event.target.mute();
          setTimeout(() => event.target.playVideo(), 500);
        },
        'onStateChange': (event) => {
          if (event.data === YT.PlayerState.ENDED) {
            event.target.seekTo(0);
            event.target.playVideo();
          }
        },
        'onError': (data) => {
          console.log(data);
        }
      },
    });

    const closeModal = (modal) => {
      modal.classList.add('fade-out');
      setTimeout(() => {
        modal.remove();
        player.destroy();
      }, 500);
    };

    modal.querySelector('.youtube-modal-close').addEventListener('click', () => {
      closeModal(modal);
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeModal(modal);
      }
    });
  };
};